import dynamic from 'next/dynamic'
import type { ComponentType } from 'react'
import type { LinkCompType } from '../navUtils'

interface NavModuleProps {
  id: string
  LinkComp: LinkCompType
}

const comp: Record<string, ComponentType<NavModuleProps>> = {}
//prettier-ignore
{
  comp['features'] = dynamic(() => import("./Features"));
  comp['provenResults'] = dynamic(() => import("./ProvenResults"));
  comp['products'] = dynamic(() => import("./Products"));
  comp['resources'] = dynamic(() => import("./Resources"));
}

export function NavigationModule({
  id,
  LinkComp,
}: {
  id: string
  LinkComp: LinkCompType
}) {
  const Component = getBlockComponent(id)
  return <Component id={id} LinkComp={LinkComp} />
}

function getBlockComponent(id: string): ComponentType<NavModuleProps> {
  return comp[id] ?? ComponentNotFound
}

function ComponentNotFound({ id }: NavModuleProps) {
  return (
    <div className="inline-block self-center rounded-md border border-slate-400 bg-slate-300 p-4 font-mono">
      Component <span className="font-bold">{id}</span> not found
    </div>
  )
}
